import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles.css'
import 'boxicons'

import PrismicVue from '@prismicio/vue'
import linkResolver from './link-resolver';

const accessToken = 'MC5YX0tRU1JBQUFDTUE1VjdN.E2Hvv70fFC8y77-977-9He-_vXPvv70J77-977-977-977-977-977-977-977-977-977-9Uu-_ve-_ve-_vXFRESc';

// Add this before the new Vue instance
Vue.use(PrismicVue, {
  endpoint: "https://sheldonzhangportfoilio.cdn.prismic.io/api/v2",
  linkResolver,
  apiOptions: { accessToken }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
